import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useMemo } from 'react';
import { getTestIds } from '../../utils/TestIds';
import styles from './PasswordStrengthMeter.module.scss';
export const GetPasswordStrengthMeterTID = (parentTestId)=>getTestIds(parentTestId);
const STRENGTH_DISPLAYS = {
    weak: {
        width: '30%',
        label: 'Password is too weak - try making it longer and less predictable'
    },
    good: {
        width: '64%',
        label: 'Good to go'
    },
    strong: {
        width: '100%',
        label: 'Strong'
    }
};
function strengthLevelFromScore(score) {
    if (score >= 4) return 'strong';
    if (score >= 3) return 'good';
    return 'weak';
}
export const PasswordStrengthMeter = (param)=>{
    let { score, testId } = param;
    const testIds = useMemo(()=>GetPasswordStrengthMeterTID(testId), [
        testId
    ]);
    if (score === null) return null;
    const level = strengthLevelFromScore(score);
    const display = STRENGTH_DISPLAYS[level];
    return /*#__PURE__*/ _jsxs("div", {
        className: styles.root,
        "data-testid": testIds.PasswordStrengthMeterTestIds.Root(),
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: styles.track,
                "data-testid": testIds.PasswordStrengthMeterTestIds.Track(),
                children: /*#__PURE__*/ _jsx("div", {
                    className: "".concat(styles.fill, " ").concat(styles[level]),
                    style: {
                        width: display.width
                    },
                    "data-testid": testIds.PasswordStrengthMeterTestIds.Fill()
                })
            }),
            /*#__PURE__*/ _jsx("span", {
                className: styles.label,
                "data-testid": testIds.PasswordStrengthMeterTestIds.Label(),
                children: display.label
            })
        ]
    });
};
